import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43c0367c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frisbuy-popup-inner" }
const _hoisted_2 = { class: "frisbuy-popup-content" }
const _hoisted_3 = { class: "frisbuy-popup-content__image" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "29",
  height: "31",
  viewBox: "0 0 29 31",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("g", { filter: "url(#filter0_d_4369_3101)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M21.4186 12.7112C23.5271 13.9506 23.5271 17.0494 21.4186 18.2888L10.7442 24.5638C8.63566 25.8032 6 24.2539 6 21.7749L6 9.22509C6 6.74611 8.63566 5.19675 10.7442 6.43624L21.4186 12.7112Z",
      fill: "white"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("filter", {
      id: "filter0_d_4369_3101",
      x: "-3",
      y: "-2",
      width: "35",
      height: "35",
      filterUnits: "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }, [
      /*#__PURE__*/_createElementVNode("feFlood", {
        "flood-opacity": "0",
        result: "BackgroundImageFix"
      }),
      /*#__PURE__*/_createElementVNode("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }),
      /*#__PURE__*/_createElementVNode("feOffset"),
      /*#__PURE__*/_createElementVNode("feGaussianBlur", { stdDeviation: "3" }),
      /*#__PURE__*/_createElementVNode("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.36 0"
      }),
      /*#__PURE__*/_createElementVNode("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4369_3101"
      }),
      /*#__PURE__*/_createElementVNode("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_4369_3101",
        result: "shape"
      })
    ])
  ])
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "frisbuy-popup-content__info" }
const _hoisted_9 = {
  key: 0,
  class: "frisbuy-popup-customers-reviews"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Другие фото из отзывов", -1))
const _hoisted_11 = { class: "frisbuy-popup-media-list" }

import {
  ref,
  watch,
  withDefaults,
  computed,
  onMounted,
  onBeforeUnmount,
  nextTick,
} from "vue";
// Components
import PopupContainer from "../PopupContainer/PopupContainer.vue";
import CustomerReview from "../CustomerReview.vue";
import MediaList from "../MediaList.vue";
import ArrowButton from "../ArrowButton.vue";
// Services
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
// Consts
import widgetTypes from "@/common/consts/widgetTypes";
// Types
import { IPostMedia } from "@/gallery/interfaces";
import { TSwipe } from "../../globals";
import { imageWithPostId, IMarketplaceReviewsPost } from "../../interfaces";

const errorImagePlug = "https://www.frisbuy.ru/images/empty_media.png";

export default /*#__PURE__*/_defineComponent({
  __name: 'PopupReviewPost',
  props: {
    post: {},
    selectedMediaIndex: {},
    showLeftArrow: { type: Boolean, default: true },
    showRightArrow: { type: Boolean, default: true },
    settings: {},
    allCustomersMediaList: { default: () => [] },
    reviewDate: {},
    reviewTime: {},
    reviewMarketplace: {}
  },
  emits: [
  "selectPrevPost",
  "selectNextPost",
  "close",
  "selectPost",
  "requestToLoadCustomersMedia",
  "sendAnaliticEvent",
],
  setup(__props: any, { emit: __emit }) {

// Modules
const props = __props;

const emit = __emit;

const currentMediaIndex = ref<number>(props.selectedMediaIndex);

const currentMedia = computed<IPostMedia>(() => {
  return props.post.media[currentMediaIndex.value];
});

const selectedImage = ref<string | undefined>(
  currentMedia.value.imageHighResolutionUrl
);

watch(
  () => [props.post, props.selectedMediaIndex],
  () => {
    // TODO: try to rewrite next line as v-model
    currentMediaIndex.value = props.selectedMediaIndex;

    selectedImage.value =
      props.post.media[props.selectedMediaIndex].imageHighResolutionUrl;
  }
);

function selectPrevPost() {
  emit("selectPrevPost");
}

function selectNextPost() {
  emit("selectNextPost");
}

function swipePost(direction: TSwipe) {
  if (direction === "left") {
    selectNextPost();
  }

  if (direction === "right") {
    selectPrevPost();
  }
}

function closePopup() {
  emit("close");
}

function selectMedia(media: imageWithPostId) {
  if (isVideoPlaying.value) {
    stopVideo();
  }

  const postId =
    props.post.instagramPost?.frisbuyId || props.post.providerPost?.frisbuyId;
  selectPost(postId, media);
}

const videoElement = ref<HTMLVideoElement | null>(null);
const isVideoPlaying = ref(false);
function playVideo() {
  if (!videoElement.value) {
    console.warn("videoElement is 'null'");
    return;
  }

  emit("sendAnaliticEvent", "PlayVideo", {
    provPostId: props.post.instagramPost?.frisbuyId ?? props.post.providerPost.frisbuyId,
    fbProduct: props.post.frisbuyPost.id,
    igCode: props.post.instagramPost.shortcode,
  });


  isVideoPlaying.value = true;

  videoElement.value.play();
}

function pauseVideo() {
  if (!videoElement.value) {
    console.warn("videoElement is 'null'");
    return;
  }

  isVideoPlaying.value = false;

  videoElement.value.pause();
}

function stopVideo() {
  if (!videoElement.value) {
    console.warn("videoElement is 'null'");
    return;
  }

  isVideoPlaying.value = false;

  videoElement.value.pause();
  videoElement.value.currentTime = 0;
}

// Customers photo
function selectPost(postId: number, media?: imageWithPostId) {
  if (isVideoPlaying.value) {
    stopVideo();
  }

  emit("selectPost", postId, media);
}

// Customers photo loading on scroll
function loadCustomersMediaOnScroll(scrollPos: {
  top: number;
  bottom: number;
}) {
  if (scrollPos.bottom <= 0) {
    emit("requestToLoadCustomersMedia");
  }
}

// MediaList items size
onMounted(() => {
  changeAllCustomersMediaListItemsWidth();
  window.addEventListener("resize", changeAllCustomersMediaListItemsWidth);

  changeReviewMediaListItemsWidth();
  window.addEventListener("resize", changeReviewMediaListItemsWidth);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", changeAllCustomersMediaListItemsWidth);
  window.removeEventListener("resize", changeReviewMediaListItemsWidth);
});

const reviewMediaListItemsWidth = ref<string>();
function changeReviewMediaListItemsWidth() {
  let itemsWidth = "65px";

  if (document.body.clientWidth <= 1024) {
    itemsWidth = "87px";
  }

  reviewMediaListItemsWidth.value = itemsWidth;
}

let allCustomersMediaListItemsWidth = ref<string>();
function changeAllCustomersMediaListItemsWidth() {
  let gap = "5px";
  let itemsInRow = 6;

  if (document.body.clientWidth <= 767) {
    itemsInRow = 2;
  } else if (document.body.clientWidth <= 1024) {
    itemsInRow = 3;
  } else {
    itemsInRow = 6;
  }

  allCustomersMediaListItemsWidth.value = `calc(1 / ${itemsInRow} * 100% - calc(${gap} * ${
    (itemsInRow - 1) / itemsInRow
  })`;
}

function errorImageHandler(e: Event) {
  MediaCatcher(e, 2, widgetTypes.STORY);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupContainer, {
    onClose: closePopup,
    onBlur: closePopup,
    onSwipe: _cache[2] || (_cache[2] = (direction) => swipePost(direction)),
    onScroll: _cache[3] || (_cache[3] = (scrollPos) => loadCustomersMediaOnScroll(scrollPos))
  }, {
    content: _withCtx((contentWrapper) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.showLeftArrow)
            ? (_openBlock(), _createBlock(ArrowButton, {
                key: 0,
                customClass: "frisbuy-popup-content__button",
                direction: "left",
                onClick: selectPrevPost
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _unref(DomainSubstitute)(selectedImage.value),
              onError: errorImageHandler
            }, null, 40, _hoisted_4),
            (currentMedia.value.videoUrl && !isVideoPlaying.value)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "frisbuy-popup-content__play-icon",
                  onClick: playVideo
                }, _hoisted_6))
              : _createCommentVNode("", true),
            (currentMedia.value.videoUrl)
              ? _withDirectives((_openBlock(), _createElementBlock("video", {
                  key: 1,
                  src: currentMedia.value.videoUrl,
                  controls: "",
                  loop: "true",
                  controlsList: "nodownload",
                  playsinline: "",
                  ref_key: "videoElement",
                  ref: videoElement,
                  onPause: _cache[0] || (_cache[0] = ($event: any) => (videoElement.value && pauseVideo))
                }, null, 40, _hoisted_7)), [
                  [_vShow, isVideoPlaying.value]
                ])
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(CustomerReview, {
              customerName: 
                _ctx.post.instagramPost.authorUser.fio ||
                `@${_ctx.post.instagramPost.authorUser.username}`
              ,
              reviewDate: props.reviewDate,
              reviewTime: props.reviewTime,
              reviewMarketplace: props.reviewMarketplace,
              rating: _ctx.post.frisbuyPost.rating,
              negativeComment: _ctx.post.frisbuyPost.negativeComment,
              positiveComment: _ctx.post.frisbuyPost.positiveComment,
              text: _ctx.post.frisbuyPost.text,
              mediaList: props.post.media,
              sectionsMarginTop: ['0', '20px', '30px'],
              mediaSectionConfig: {
                margin: '30px 0 0 0',
                order: 2,

                wrap: 'wrap',
                mediaWidth: reviewMediaListItemsWidth.value,
              },
              textSectionConfig: {
                margin: '20px 0 0 0',
                order: 1,
              },
              onSelectMedia: _cache[1] || (_cache[1] = (media) => selectMedia(media))
            }, null, 8, ["customerName", "reviewDate", "reviewTime", "reviewMarketplace", "rating", "negativeComment", "positiveComment", "text", "mediaList", "mediaSectionConfig"])
          ]),
          (_ctx.showRightArrow)
            ? (_openBlock(), _createBlock(ArrowButton, {
                key: 1,
                customClass: "frisbuy-popup-content__button",
                direction: "right",
                onClick: selectNextPost
              }))
            : _createCommentVNode("", true)
        ]),
        (_ctx.allCustomersMediaList.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createVNode(MediaList, {
                  mediaList: props.allCustomersMediaList,
                  mediaWidth: _unref(allCustomersMediaListItemsWidth),
                  wrap: "wrap",
                  onSelectMedia: 
                (media) => {
                  selectPost(media.postId, media);

                  // NOTE: `nextTick` only for fix Safari
                  nextTick(() => {
                    contentWrapper.scrollToTop();
                  });
                }
              
                }, null, 8, ["mediaList", "mediaWidth", "onSelectMedia"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})